import { useContext } from 'react';
import { MyCompanyUsersContext, MyCompanyUsersContextData } from './context';

export function useMyCompanyUsers(): MyCompanyUsersContextData {
    const data = useContext<MyCompanyUsersContextData | undefined>(
        MyCompanyUsersContext
    );

    if (!data) {
        throw new Error(
            "MyCompanyUsersContext unavailable. Are you sure you're using this in a nested component of a MyCompanyUsersProvider?"
        );
    }

    return data;
}
